import React from "react";
import TickSquareFill from "../assets/icons/TickSquareFill";
import TickSquareUnfill from "../assets/icons/TickSquareUnfill";

const CheckboxInput = ({ name, id, label, onChange, checked, typename }) => {
  return (
    <div className="checkbox-label">
      <input
        type={typename}
        name={name} 
        id={id}
        onChange={onChange}
        checked={checked}
      />
      <label htmlFor={id}> 
        <span className="tick-icon">
          <TickSquareFill color="#fff" />
        </span>
        <span className="add-icon">
          <TickSquareUnfill color="#fff" />
        </span>
        {label}
      </label>
    </div>
  );
};

export default CheckboxInput;

